import SVGIcon from "./SVGIcon.js";

type Props = {
  [props: string]: string | number;
};

const Close = (props: Props) => (
  <SVGIcon
    className="svg-close-icon"
    pathD={[
      "M6.856,25.664l3.953-5.489q0.226-.322.752-1.182,0.354,0.569.688,1.053l3.964,5.618h2.578l-5.962-8.325,5.532-7.423H16.094l-3.169,4.179a20.532,20.532,0,0,0-1.246,1.794,23.038,23.038,0,0,0-1.268-1.934L7.554,9.915H5.073l5.371,7.541L4.353,25.664h2.5Z",
    ]}
    width={15}
    height={15}
    viewBox="0 0 30 30"
    transform="translate(-4 -10)"
    {...props}
  />
);

export default Close;
